export const LAYOUT_RESIZE    = 'layout/resize';

export const AUTH_CHECK    = 'auth/check';
export const AUTH_USER     = 'auth/user';

export const LOGIN   = 'login';
export const LOGOUT  = 'logout';

export const LOAD_TAC   = 'tac/load';
export const ACCEPT_TAC = 'tac/accept';

export const SHOW_LOAD_METADATA  = 'show/load';
export const SHOW_CLEAR_METADATA = 'show/clear';
export const SHOWS_LOAD          = 'shows/load';
export const SHOW_EXIT           = 'show/exit';


export const CLIPS_LOAD             = 'clips/load';
export const CLIPS_RESET_FACETS     = 'clips/reset_facets';
export const CLIPS_RESELECT_FACETS  = 'clips/reselect_facets';
export const CLIPS_CHANGE_PAGE      = 'clips/change_page';
export const CLIPS_CHANGE_PAGE_SIZE = 'clips/change_items_per_page';
export const CLIPS_LOAD_MORE_FACETS = 'clips/facets';
export const CLIPS_SEARCH           = 'clips/search';
export const CLIPS_RESET_FILTER     = 'clips/reset';
export const CLIPS_APPLY_NEXT_PAGE  = 'clips/apply_next_page';
export const CLIPS_DOWNLOAD         = 'clips/download';

export const SEARCH_CHANGE_TYPE     = 'search/change_type';
export const CLEAR_SEARCH_COUNTER   = 'search/clear_counter';
export const SEARCH_CHANGE_FIELDS   = 'search/change_fields';
export const SYNC_SEARCH_STATE      = 'search/sync-state';
export const CHANGE_SEARCH_VIEW_MODE   = 'search/change_mode';


export const ADD_TO_CART      = 'cart/add';
export const REMOVE_FROM_CART = 'cart/remove_clip';
export const REMOVE_CART      = 'cart/remove';
export const CART_LOAD        = 'cart/load';
export const CART_LOAD_BY_ID  = 'cart/load_by_id';
export const CHECKOUT_CART    = 'cart/checkout';
export const CHANGE_CART_PAGE = 'cart/change_page';

export const EPISODE_LOAD     = 'episode/load';


export const SHOW_ERROR_NOTIFICATION   = 'notification/error';
export const SHOW_SUCCESS_NOTIFICATION = 'notification/success';
export const SHOW_INFO_NOTIFICATION = 'notification/info';
export const HIDE_NOTIFICATION         = 'notification/hide';
